<template>
  <div class="outer-wrap">
    <Sidebar
      :show="showSidebar"
      @sidebartoggle="showSidebar = !showSidebar"
      @settingstoggle="
        showSettings = !showSettings;
        showMonitor = false;
        showSidebar = false;
      "
      @monitortoggle="
        showMonitor = !showMonitor;
        showSettings = false;
        showSidebar = false;
      "
    />
    <NavBar
      v-show="true"
      id="navbar"
      @logout="logoutSession"
      @sidebartoggle="showSidebar = !showSidebar"
    />
    <div class="stat" id="page-wrap">
      <!-- Settings -->
      <transition name="settings">
        <Settings
          id="set"
          v-if="showSettings"
          :selectedStructure="this.getStructureDetails"
          @settingstoggle="showSettings = !showSettings"
        />
      </transition>
      <!-- Monitor -->
      <transition name="settings">
        <Monitor
          id="monitor"
          v-if="showMonitor"
          :selectedStructure="this.getStructureDetails"
          @monitortoggle="showMonitor = !showMonitor"
        />
      </transition>
      <!-- Loading -->
      <transition name="load">
        <LoadingLogo v-if="!this.loaded" />
      </transition>
      <!-- Selezione Struttura -->
      <BridgeOverview
        id="bridge-ow"
        :bridges="this.getStructures"
        :selectedBridge="this.getStructureDetails"
        v-if="this.loaded && this.getStructureDetails"
        @struct-selected="selectStructure"
      />
      <div class="container" v-if="tiltmeterList.length > 1">
      <!-- Deformata -->
      <div class="sub-wrapper" v-if="this.getStructureDetails && this.getStructureDetails._id">
        <Deflection v-for="(span, index) in spans" :spanNumber="index + 1" :spanName="span.name" :spanLength="span.length" :key="index" :structureDetails="getStructureDetails"/>
      </div>
      </div>
      <div class="warning-container" v-else>
        <h2 v-if="loaded">No tiltmeters found.</h2>
      </div>
      <Footer />
    </div>
  </div>
</template>
<script>
import BridgeOverview from "../components/ui/BridgeOverview.vue";
import Deflection from "../components/modules/dashboard/deflection.vue";
import NavBar from "../components/ui/NavigationBar.vue";
import Sidebar from "../components/ui/Sidebar.vue";
import Settings from "./Settings";
import Monitor from "./Monitor";
import Footer from "../components/ui/Footer";
import LoadingLogo from "../components/ui/LoadingLogo";
import $ from "jquery";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "app",
  data() {
    return {
      // True when api data is fetched
      loaded: false,
      showSidebar: false,
      showSettings: false,
      showMonitor: false,
    };
  },
  components: {
    NavBar,
    BridgeOverview,
    Deflection,
    Sidebar,
    Settings,
    Monitor,
    Footer,
    LoadingLogo
  },
  computed: {
    ...mapGetters("structure", [
      "getStructures",
      "getSensors",
      "getSelectedStructure",
      "getStructureDetails",
    ]),
    tiltmeterList: function() {
      return this.getSensors.filter((sensor) => sensor.type === "tiltmeter");
    },
    spans(){
      return (this.getStructureDetails && this.getStructureDetails.userConfig) ? this.getStructureDetails.userConfig.spansDetails : [];
    },
    rails(){
      return (this.getStructureDetails && this.getStructureDetails.userConfig) ? this.getStructureDetails.userConfig.railsDetails : [];
    }
  },
  methods: {
    ...mapActions({
      fetchStructures: "structure/fetchStructures",
      fetchStructureData: "structure/fetchStructureData",
      selectStructure: "structure/selectStructure",
      setDensProb1Sens: "densProb1/setSelectedSensor",
      setDensProb2Sens: "densProb2/setSelectedSensor",
    }),
    ...mapActions("auth", ["logout"]),
    logoutSession: function() {
      this.logout();
    },
    setupNavigationSticky: function() {
      // Setta l'hiding automatico della Navigation Bar
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos - currentScrollPos > 0) {
          $("#navbar").css("-webkit-transform", "translateY(0px");
          $("#navbar").css("transform", "translateY(0px");
        } else {
          if (currentScrollPos > 50) {
            $("#navbar").css("-webkit-transform", "translateY(-50px");
            $("#navbar").css("transform", "translateY(-50px");
          }
        }
        prevScrollpos = currentScrollPos;
      };
    }
  },
  watch: {
    getSelectedStructure: {
      handler: async function() {
        this.loaded = false;
        await this.fetchStructureData();
        this.loaded = true;
      },
      deep: true,
    },
  },
  async mounted() {
    await this.fetchStructures();
    await this.selectStructure(this.getStructures[0]);
    this.setupNavigationSticky();
  },
};
</script>

<style scoped>
/* NavBar */
#navbar {
  transition: transform 0.3s;
  position: fixed;
  width: 100%;
  min-width: 840px;
  margin-bottom: 50px;
}

#bridge-ow {
  max-width: 100vw;
}
.stat {
  position: absolute;
  display: grid;
  background-color: rgb(32, 34, 47);
  font-size: 1em;
  padding-top: 50px;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
  width: 100%;
  right: 0px;
  /* Transizioni usate per la Sidebar */
  -webkit-transition: transform 0.6s ease-in-out;
  -moz-transition: transform 0.6s ease-in-out;
  -o-transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
}

/* Tra 600 e 1499 */
@media all and (max-width: 1799px) and (min-width: 300px) {
  .stat {
    font-size: 0.8em;
  }
}

/* Loading Transition */
.load-enter,
.load-leave-to {
  opacity: 0;
}
.load-enter-active {
  transition: all 0.3s ease;
}
.load-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

#set {
  z-index: 12;
}

#monitor {
  z-index: 12;
}
</style>
